export default __webpack_public_path__ + "static/media/csharp.e2c0510d.svg";